import React, {useEffect, useState} from 'react'
import {Pagination} from '../../../../components/Pagination'
import Aprobar from '../../../../media/felsv/DarkAprobarUsuario.svg'
import DownloadIcon from '../../../../media/felsv/dark_download_icon.svg'
import Edit from '../../../../media/felsv/DarkEditPencil.svg'
import Reload from '../../../../media/felsv/DarkReload.svg'
import Recycle from '../../../../media/felsv/DarkRecycleDelete.svg'
import AddHome from '../../../../media/felsv/addhome.svg'
import Open_Eye from '../../../../media/felsv/Open_Eye.svg'
import Close_Eye from '../../../../media/felsv/Close_Eye.svg'

import '../styles/table-list-usuario.css'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {State} from '../../../../reducers'

import {
  gu_lu_OpenModalAceptarRechazar,
  gu_lu_OpenModalEliminarUsuario,
  gu_lu_OpenModalResetPassword,
  gu_lu_OpenModalPrint,
  gu_lu_OpenModalEstatus,
  gu_lu_OpenModalSucursales,
  gu_lu_SetUsuarioSeleccionado,
} from '../../../../actions/gestion-usuario/lista-usuario/listaUsuario.actions'
import {actionsGUEditarUsuario} from '../../../../actions/action-creators'

import {Tooltip} from '@mui/material'
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'

const TableListUsuario = () => {
  const [currentItems, setCurrentItems] = useState<Array<any>>([])
  const [sortedData, setSortedData] = useState<Array<any>>([])
  const usuarios = useSelector((state: State) => state.gestionUsuario.listarUsuarios.usuarios)
  const history = useHistory()
  const dispatch = useDispatch()
  const actionsEditar = bindActionCreators(actionsGUEditarUsuario, dispatch)

  useEffect(() => {
    setSortedData(
      usuarios.map((usuario) => ({
        ...usuario,
        filter_sucursales: usuario?.sucursales?.length,
      }))
    )
  }, [usuarios])

  const clicAceptarRechazar = (usuario: any) => {
    dispatch(gu_lu_OpenModalAceptarRechazar(true))
    seleccionarUsuario(usuario)
  }

  const clicResetPassword = (usuario: any) => {
    dispatch(gu_lu_OpenModalResetPassword(true))
    seleccionarUsuario(usuario)
  }

  const clicEliminarUsuario = (usuario: any) => {
    dispatch(gu_lu_OpenModalEliminarUsuario(true))
    seleccionarUsuario(usuario)
  }

  const seleccionarUsuario = (usuario: any) => {
    dispatch(gu_lu_SetUsuarioSeleccionado(usuario))
  }

  const clicEditarUsuario = async (usuario: any) => {
    await actionsEditar.gu_eu_OpenEditar(usuario)
    history.push('/gestion-usuarios/editar-usuario')
  }

  const clicControlActivoUsuario = async (usuario: any, accion: boolean) => {
    dispatch(gu_lu_SetUsuarioSeleccionado({...usuario, accionEstatus: accion}));
    dispatch(gu_lu_OpenModalEstatus(true));
  } 

  const clickImprimirFicha = (usuario: any) => {
    seleccionarUsuario(usuario);
    dispatch(gu_lu_OpenModalPrint(true));
  }

  const clicAsignarDesasignarSucursal = async (usuario: any) => {
    const newUsuario = {...usuario}
    if (Array.isArray(usuario?.sucursales)) {
      newUsuario.arraySucursalesAsignadas = usuario.sucursales.map((el: any) =>
        String(el?.sucursal_idsucursal)
      )
    }
    newUsuario.flagAsignacion = true
    seleccionarUsuario(newUsuario)
    dispatch(gu_lu_OpenModalSucursales(true))
  }

  return (
    <div className='container-white w-100' style={{overflowX: 'auto'}}>
      <h4 className='h4-titles'>Resultados obtenidos</h4>
      <div className='tab-plane mt-16' style={{overflowX: 'auto'}}>
        <table className='tlu-table-main-responsive tlu-responsive-table-main td-left table-pointer'>
          <thead>
            <tr>
              <td>Acciones</td>
              <td>
                Sucursales{' '}
                <FilterButton
                  data={sortedData}
                  keyName='filter_sucursales'
                  state={(items: Array<any>) => setSortedData(items)}
                />
              </td>
              <td>
                Nombre de usuario{' '}
                <FilterButton
                  data={sortedData}
                  keyName='username'
                  state={(items: Array<any>) => setSortedData(items)}
                />
              </td>
              <td>
                No. documento{' '}
                <FilterButton
                  data={sortedData}
                  keyName='id_number'
                  state={(items: Array<any>) => setSortedData(items)}
                />
              </td>
              <td>
                Nombre completo{' '}
                <FilterButton
                  data={sortedData}
                  keyName='first_name'
                  state={(items: Array<any>) => setSortedData(items)}
                />
              </td>
              <td>
                Empresa{' '}
                <FilterButton
                  data={sortedData}
                  keyName='empresa'
                  state={(items: Array<any>) => setSortedData(items)}
                />
              </td>
              <td>
                Estado{' '}
                <FilterButton
                  data={sortedData}
                  keyName='estado_descripcion'
                  state={(items: Array<any>) => setSortedData(items)}
                />
              </td>
            </tr>
          </thead>
          <tbody>
            {usuarios.length === 0 && (
              <tr>
                <td colSpan={8}>
                  <div
                    style={{
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '20px',
                      padding: '1%',
                    }}
                  >
                    Sin datos disponibles.
                  </div>
                </td>
              </tr>
            )}
            {usuarios.length > 0 &&
              currentItems.map((usuario, index) => {
                if (!usuario?.username?.split('~')[1]) {
                  return (
                    <tr key={index} onClick={() => {}}>
                      <td data-label='Acciones' className='table-td'>
                        {/* USUARIO EN PASOS DE CREACION */}
                        {
                          (usuario?.estado_usuario > 4) 
                          ? 
                          (
                            <>
                              {/* ACCIONES PARA USUARIO EN CREACION */}
                              <Tooltip title='Eliminar Usuario' arrow>
                                <button
                                  className='table-action'
                                  onClick={() => clicEliminarUsuario(usuario)}
                                >
                                  <img
                                    src={Recycle}
                                    alt='Eliminar Usuario'
                                    className='table-img-action'
                                  />
                                </button>
                              </Tooltip>
                            </>
                          )
                          :
                          (
                            <>
                              {/* ESTADOS DE USUARIO YA CREADO */}
                              {/* ---------------------------- */}
                              {
                                !usuario?.default_socio && 
                                (
                                  <>
                                    {/* USUARIO CON ESTADO PENDIENTE */}
                                    {usuario?.estado_usuario === 3 && usuario?.correo_verificado && (
                                      <Tooltip title='Aceptar/Rechazar' arrow>
                                        <button
                                          className='table-action'
                                          onClick={() => clicAceptarRechazar(usuario)}
                                        >
                                          <img
                                            src={Aprobar}
                                            alt='Aceptar o Rechazar'
                                            className='table-img-action'
                                          />
                                        </button>
                                      </Tooltip>
                                    )}
                                    {/* USUARIO QUE NO ESTE RECHAZADO NI PENDIENTE */}
                                    {usuario?.estado_usuario !== 2 && usuario?.estado_usuario !== 3 && usuario?.correo_verificado && (
                                      <>
                                      <Tooltip title='Imprimir' arrow>
                                          <button
                                            className='table-action'
                                            onClick={() => clickImprimirFicha(usuario)}
                                          >
                                            <img
                                              src={DownloadIcon}
                                              alt='Imprimir'
                                              className='table-img-action'
                                            />
                                          </button>
                                        </Tooltip>
                                      
                                      </>
                                    )}
                                    {/* ACTIVAR - USUARIO QUE ESTE ACTIVO O EN PROCESO DE CONTRASEÑA */}
                                    {((usuario?.estado_usuario === 1 && usuario?.correo_verificado) || (usuario?.estado_usuario === 4)) && (
                                      <>
                                        <Tooltip title={usuario?.eliminado ? 'Activar' : 'Desactivar'} arrow>
                                          <button
                                            className='table-action'
                                            onClick={() => clicControlActivoUsuario(usuario, usuario?.eliminado)}
                                          >
                                            <img src={usuario?.eliminado ? Close_Eye : Open_Eye} alt='Habilitar usuario' className='table-img-action' />
                                          </button>
                                        </Tooltip>
                                      </>
                                    )}

                                    {/* REINICIAR CONTRASENIA - USUARIO NO ESTE EN PROCESO DE CONTRASEÑA, NO ESTE RECHAZADO, NI PENDIENTE */}
                                    {
                                      (
                                        usuario?.estado_usuario !== 2 && 
                                        usuario?.estado_usuario !== 3 && 
                                        usuario?.correo_verificado &&
                                        !usuario?.eliminado
                                      ) && (
                                      <Tooltip title='Reiniciar Contraseña' arrow>
                                        <button
                                          className='table-action'
                                          onClick={() => clicResetPassword(usuario)}
                                        >
                                          <img
                                            src={Reload}
                                            alt='Reiniciar Contraseña'
                                            className='table-img-action'
                                          />
                                        </button>
                                      </Tooltip>
                                    )}
                                    {/* ELIMINAR - USUARIO NO ACTIVO, NO VERIFICADO Y/O NO DESHABILITADO */}
                                    {
                                      !(
                                        usuario?.estado_usuario === 1 && 
                                        usuario?.correo_verificado && 
                                        !usuario?.eliminado
                                      ) && (
                                      <Tooltip title='Eliminar Usuario' arrow>
                                        <button
                                          className='table-action'
                                          onClick={() => clicEliminarUsuario(usuario)}
                                        >
                                          <img
                                            src={Recycle}
                                            alt='Eliminar Usuario'
                                            className='table-img-action'
                                          />
                                        </button>
                                      </Tooltip>
                                    )}
                                  </>
                                )
                              }
                              
                              {/* ASIGNAR SUCURSALES - USUARIO ACTIVO VERIFICADO Y NO DESHABILITADO */}
                              {
                                (
                                  usuario?.estado_usuario === 1 && 
                                  usuario?.correo_verificado && 
                                  !usuario?.eliminado
                                ) && (
                                  <>
                                    <Tooltip title='Asignar / Desasignar Sucrusales' arrow>
                                      <button
                                        className='table-action'
                                        onClick={() => clicAsignarDesasignarSucursal(usuario)}
                                      >
                                        <img
                                          src={AddHome}
                                          alt='Asignar/Desasignar sucursales'
                                          className='table-img-action'
                                        />
                                      </button>
                                    </Tooltip>
                                    {!usuario?.default_socio && 
                                    (
                                      <Tooltip title='Editar Usuario' arrow>
                                        <button
                                          className='table-action'
                                          onClick={() => clicEditarUsuario(usuario)}
                                        >
                                          <img src={Edit} alt='Editar Usuario' className='table-img-action' />
                                        </button>
                                      </Tooltip>
                                    )}
                                  </>
                              )}
                            </>
                          )
                        }
                      </td>
                      <td data-label='Sucursales'>{usuario?.sucursales?.length}</td>
                      <td data-label='ID Usuario'>{usuario?.username}</td>
                      <td data-label='No. Documento'>{usuario?.id_number}</td>
                      <td data-label='Nombre completo'>
                        {usuario?.first_name} {usuario?.second_name || ''}{' '}
                        {usuario?.third_name || ''} {usuario?.last_name || ''}{' '}
                        {usuario?.last_name2 || ''} {usuario?.last_name_married || ''}
                      </td>
                      <td data-label='Empresa'>{usuario?.empresa}</td>
                      <td data-label='Estado'>
                        <div style={{justifyContent: 'center', width: '100%', display: 'flex'}}>
                          <div className='lista-usuario-estado-activo' style={{background: usuario?.estado_color}}>
                            {usuario?.estado_descripcion ?? '---'}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )
                }
              })}
          </tbody>
        </table>
        <Pagination
          data={sortedData}
          state={(items: Array<any>) => setCurrentItems(items)}
          items={15}
        />
      </div>
    </div>
  )
}

export default TableListUsuario
